import { createAction, props } from "@ngrx/store";
import { Position } from "../../models/position";

/*CRUD CATALOG POSITIONS*/

export const findPositionAct = createAction('findPositionEffect', props <{ id: number }>());
export const loadPositionByIdAct = createAction('loadPositionByIdEffect', props<{ position: Position }>());

export const savePositionAct = createAction('savePositionEffect', props<{ positionNew: Position }>());
export const saveSuccessPositionAct = createAction('saveSuccessPositionEffect', props<{ positionNew: Position }>());

export const updatePositionAct = createAction('updatePositionEffect', props<{ positionUpdated: Position }>());
export const updateSuccessPositionAct = createAction('updateSuccessPositionEffect', props<{ positionUpdated: Position }>());
/*CRUD CATALOG POSITIONS END*/
export const setViolationsPositionAct = createAction('setViolationsPositionEffect', props<{ positionForm: Position, violations: {} }>());
export const showMsgErrorAct = createAction('showMsgErrorEffect', props<{ error: any }>() );